module.exports = __webpack_public_path__ + "static/img/et.2ebb0d3d.svg";